import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
var maxLabelLength = 70;
export default function TreeListItem(_ref) {
  var classes = _ref.classes,
    isRootNode = _ref.isRootNode,
    nodeId = _ref.nodeId,
    label = _ref.label,
    options = _ref.options,
    expandedNodeIds = _ref.expandedNodeIds,
    selectedNodeIds = _ref.selectedNodeIds,
    halfSelectedNodeIds = _ref.halfSelectedNodeIds,
    handleSelect = _ref.handleSelect,
    highlightText = _ref.highlightText,
    handleEdit = _ref.handleEdit,
    editableNodeIdSet = _ref.editableNodeIdSet,
    radioTreeMode = _ref.radioTreeMode,
    _ref$showCheckBoxes = _ref.showCheckBoxes,
    showCheckBoxes = _ref$showCheckBoxes === void 0 ? true : _ref$showCheckBoxes;
  /**
   * Handler
   */
  var handleChecked = function handleChecked(nodes, checked, nodeId, options) {
    var index = nodes.indexOf(nodeId);
    if (!checked && index >= 0) {
      nodes.splice(index, 1);
    } else if (checked && index < 0) {
      if (radioTreeMode === true) {
        nodes.length = 0;
        nodes.push(nodeId);
      } else {
        nodes.push(nodeId);
      }
    }
    if (radioTreeMode !== true && options) {
      options.forEach(function (option) {
        return handleChecked(nodes, checked, option.id, option.children);
      });
    }
  };

  /**
   * Handler
   */
  var handleClick = function handleClick(event) {
    // Only stop propagation if already expanded or if the value is false
    var checked = event.target.checked;
    if (expandedNodeIds.includes(nodeId) || !checked) {
      event.stopPropagation();
    }
    var selectedClone = _toConsumableArray(selectedNodeIds);
    handleChecked(selectedClone, checked, nodeId, options);
    handleSelect(event, selectedClone);
  };

  //
  // Item label
  //
  var trimmedLabel = label;
  if (trimmedLabel.length > maxLabelLength) {
    trimmedLabel = label.substring(0, maxLabelLength) + "...";
  }
  var labelWithHighlightedText = trimmedLabel;
  if (!isRootNode) {
    if (highlightText) {
      var index = label.toLowerCase().indexOf(highlightText);
      if (index >= 0) {
        labelWithHighlightedText = /*#__PURE__*/React.createElement("span", null, label.substring(0, index), /*#__PURE__*/React.createElement("b", {
          className: classes.highlighted
        }, label.substring(index, index + highlightText.length)), label.substring(index + highlightText.length, label.length));
      }
    }
  }

  //
  // Other options
  //
  var selected = selectedNodeIds.includes(nodeId);
  var halfSelected = !selected && halfSelectedNodeIds.includes(nodeId);
  var editable = handleEdit && options.length === 0 && editableNodeIdSet && editableNodeIdSet.has(nodeId);

  //
  // Returns the item
  //
  return /*#__PURE__*/React.createElement(TreeItem, {
    nodeId: String(nodeId),
    label: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("label", null, showCheckBoxes && /*#__PURE__*/React.createElement(Checkbox, {
      icon: halfSelected ? /*#__PURE__*/React.createElement(IndeterminateCheckBoxIcon, null) : undefined,
      color: "primary",
      onClick: handleClick,
      checked: selected
    }), labelWithHighlightedText, editable ? /*#__PURE__*/React.createElement(Tooltip, {
      title: "Customize columns"
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return handleEdit(nodeId);
      }
    }, /*#__PURE__*/React.createElement(EditIcon, null))) : null))
  }, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(TreeListItem, {
      key: index,
      classes: classes,
      nodeId: option.id,
      label: option.label,
      options: option.children,
      expandedNodeIds: expandedNodeIds,
      selectedNodeIds: selectedNodeIds,
      halfSelectedNodeIds: halfSelectedNodeIds,
      handleSelect: handleSelect,
      highlightText: highlightText,
      handleEdit: handleEdit,
      editableNodeIdSet: editableNodeIdSet,
      radioTreeMode: radioTreeMode,
      showCheckBoxes: showCheckBoxes
    });
  }));
}